import { lazyImport } from 'utils/lazyImport';
import { Navigate } from 'react-router';

const { AccountRoutes } = lazyImport(() => import('features/account'), 'AccountRoutes');
const { ProductRoutes } = lazyImport(() => import('features/products'), 'ProductRoutes');
const { BlogRoutes } = lazyImport(() => import('features/blog'), 'BlogRoutes');

export const publicRoutes = [
  {
    path: '/account/*',
    element: <AccountRoutes />,
  },
  {
    path: '/products/*',
    element: <ProductRoutes />,
  },
  {
    path: '/blog/*',
    element: <BlogRoutes />,
  },

  { path: '*', element: <Navigate to="." /> },
];
